import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';
import { ReadingPulseProvider } from '../contexts/ReadingPulseContext';
import ReadingPulse from './progress/ReadingPulse';
import Footer from './Footer';
import Sidebar from './Sidebar';
import MobileNavigation from './MobileNavigation';
import './Layout.css';

const Layout = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [online, setOnline] = useState(navigator.onLine);
  const { pathname, hash } = useLocation();
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const openSidebar = useCallback(() => setSidebarOpen(true), []);

  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
    else requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView());
  }, [pathname, hash]);

  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  return (
    <ReadingPulseProvider><div className={`layout ${isAuthenticated ? 'layout--member' : 'layout--guest'} ${user?.church ? 'has-church' : 'no-church'}`}>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Header onMenuClick={openSidebar} menuOpen={sidebarOpen} />
      {isAuthenticated && <ReadingPulse compact />}
      <main id="main-content" className="main-content" tabIndex={-1}>
        {!online && <p className="connection-status" role="status">You’re offline. Reconnect to read and save your chapters.</p>}
        {children}
      </main>
      <Footer />
      {isAuthenticated && <>
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <MobileNavigation onMenuClick={openSidebar} menuOpen={sidebarOpen} />
        {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}
      </>}
    </div></ReadingPulseProvider>
  );
};

export default Layout;
